export enum ReportCompanyType {
  allChargeDirect = 'allChargeDirect',
  allCompanies = 'allCompanies',
  individualCompany = 'individualCompany'
}

export interface IReportCompanyUnitParamsModel {
  new: boolean
  inactive: boolean
  active: boolean
  cancelled: boolean
  companyId: string
  reportCompanyType: ReportCompanyType
  ignoreChargeDirect: boolean
  startDate: string
  endDate: string
  cancelledStartDate: string
}

export interface IReportCompanyUnitModel {
  unitId: string
  productName: string
  monitoringCentre: string
  bureau: string
  plan: string
  firmware: string
  accountNo: string
  simId: string
  apn: string
  simType: string
  mobileNo: string
  simNo: string
  ip: string
  dateEdited: string
  dateLoaded: string
  dateCancelled?: string
  editedBy: string
}

export interface IReportCompanyUnitGroupModel {
  status: string
  data: IReportCompanyUnitModel[]
}
